<template>
  <!--
    Stop dialog close so users need to click the button to close it,
    otherwise you can generate the credentials and fail to copy them
   -->
  <v-dialog id="dialog" v-model="dialog" max-width="750px">
    <template v-slot:activator="{ on, attrs }">
      <v-list-item-title 
        v-bind="attrs"
        v-on="on"
      >
        Install
      </v-list-item-title>
    </template>

    <v-card>
      <v-card-title class="ml-3">Installing CLI</v-card-title>

      <v-card-text class="mt-2">
        <span class="ml-3">1. To download the CLI, run the given command.</span>
        <v-container fluid class="">
          <v-treeview
            :items="items"
            :active.sync="active"
            hoverable
            activatable
            open-on-click
            transition
          >
            <template slot="label" slot-scope="{ item }">
              {{ item.name }}
            </template>
          </v-treeview>
          
          <!-- <v-row align="center" class="mb-2 mt-4"> -->

          <markup
            class="ml-3"
            language="bash"
            :code="intstallCommand"
            :inline="false"
          ></markup>
          <!-- </v-row> -->
        </v-container>
      </v-card-text>
      <v-card-text class="mt-2">
        <span class="ml-3 mt-2">2. Once downloaded, click "generate credentials" for your CLI.</span>                

        <v-container v-if="createdUserAccessKey" fluid class="mt-2 ml-3">          
          
          <markup language="bash" :code="configureCLICommand" :inline="false"></markup>

          <v-card-text>
            <p>
              <em>Please note that once you close this window you will not be able to see the access key again as it
                is now encrypted. If you lose your access key, just generate a new one.</em>
            </p>
          </v-card-text>
    
        </v-container>
      </v-card-text>
      <v-card-actions>        
        <v-btn text @click="close()" class="primary--text"
          >Close</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          text
          
          class="primary--text ml-4"          
          
          :disabled="createdUserAccessKey ? true : false"
          @click="createUserAccessKey()"
          >
          Generate Credentials
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="stylus">
.addbtn {
  margin: 0px;
  top: auto;
  right: 20px;
  bottom: 20px;
  left: auto;
  position: fixed;
  z-index: 1;
}
</style>

<script>
import Markup from '../helpers/Markup';

export default {
  components: {
    Markup
  },  
  data() {
    return {
      dialog: false,
      active: [],
      items: [
        {
          id: 1,
          name: 'Windows',
          children: [
            { id: 2, name: 'x86', arch: 'x86', os: "windows" },
          ],
        },
        {
          id: 3,
          name: 'Linux',
          children: [
            { id: 4, name: 'AMD64 (x86)', arch: 'amd64', os: "linux" },
            { id: 5, name: '386', arch: '386', os: "linux" },
            { id: 6, name: 'ARM 64-bit', arch: 'aarch64', os: "linux" },
            { id: 7, name: 'ARM 32-bit', arch: 'arm', os: "linux" },
          ],
        },
        {
          id: 8,
          name: 'MacOS',
          children: [
            { id: 9, name: 'AMD64 (x86)', arch: 'amd64', os: "darwin" },
          ],
        }
      ]
    }
  },

  computed: {
    selected() {
      if (!this.active.length) return undefined

      const id = this.active[0]

      for (let i = 0; i < this.items.length; i++) {
        let found = this.items[i].children.find(distro => distro.id === id)
        if (found) {
          return found
        }
      }

      return undefined
    },
    intstallCommand() {
      if (this.selected){
        if (this.selected.os == "windows" )  {
          return `iwr https://downloads.synpse.net/install-cli.ps1 -useb | iex`
        } else {
          return `curl https://downloads.synpse.net/install-cli.sh | \\\n OS=` + this.selected.os + ` \\\n ARCH=` + this.selected.arch + ` \\\n bash`
        } 
      }
      return `curl https://downloads.synpse.net/install-cli.sh | bash`
    },
    loading() {
      return this.$store.state.iam.loading
    },
    error() {
      return this.$store.state.iam.error
    },
    createdUserAccessKey() {
      return this.$store.state.iam.createdUserAccessKey
    },
    configureCLICommand() {
      return `synpse configure --access-key ${this.createdUserAccessKey.value} --controller-uri ${window.location.protocol}//${window.location.host}/api \n`
    }
  },

  methods: {
    close() {
      // closing dialog
      this.$emit('clicked', '')
      this.dialog = false
      this.$store.dispatch('CleanupCreatedUserAccessKey')
    },
    createUserAccessKey () {
      const key = {
        description: 'cli-setup',
      }
      this.$store.dispatch('CreateUserAccessKey', key).then(() => {
        // Selecting the first namespace if nothing is set
        if (this.namespaceId === '' && this.namespaces.length > 0) {
          this.namespaceId = this.namespaces[0].id
        }

        this.$store.dispatch('ListUserAccessKeys')          
      })
    }
  }
}
</script>
